import Lara from "@/presets/lara";

export const checkboxPt = {
  ...Lara.checkbox,
  box: ({ context, props }) => {
    return {
      class: [
        ...Lara.checkbox.box({ context, props }).class,
        "!w-4 !h-4 !border-blue-darker",
        {
          "!bg-blue-darker": context.checked,
        },
        {
          "!peer-hover:border-blue-darker": !props.disabled && !context.checked && !props.invalid,
          "!peer-hover:bg-blue-darker": !props.disabled && context.checked,
        },
        "inline-flex items-center align-middle",
      ],
    };
  },
  icon: {
    class: [...Lara.checkbox.icon.class, "!w-3 !h-3"],
  },
};

export const dropdownPt = {
  ...Lara.dropdown,
  root: ({ props, state }) => {
    return {
      class: [
        ...Lara.dropdown.root({ props, state }).class,
        "border !border-gray-300 w-full h-10 !outline-none hover:border-university-primary focus:outline-none focus:shadow-none focus:ring-0 ring-0",
      ],
    };
  },
  panel: {
    class: [...Lara.dropdown.panel.class, "!border !border-gray-300"],
  },
};
